// extracted by mini-css-extract-plugin
export default {"lineSeparator":"LineSeparator_lineSeparator__Xv1Ql"};